module.exports = __webpack_public_path__ + "static/img/toolbox-line.cd5e32fb.svg";